import { Fragment, FunctionComponent } from "react";
import { ParseHtml } from "@pjs/security";
import { RadioGroup } from "@pjs/core-ui";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { IPrivacyProps } from "./interfaces/IPrivacyProps";
import { embedConsentRadioGroupItems } from "./consts/EmbedConsentRadioGroupItems.const";
import "./styles/privacy.css";

export const Privacy: FunctionComponent<IPrivacyProps> = (props) => {
    return (
        <Fragment>
            <h3 className="uui-privacy__title">{userUiI18n.getString("privacy.cookies.title")}</h3>
            <p className="uui-privacy__description">{userUiI18n.getString("privacy.cookies.description")}</p>
            <ParseHtml
                className="uui-privacy__cookie-policy"
                htmlString={userUiI18n.getString("privacy.cookies.tip", {
                    label: userUiI18n.getString("privacy.cookies.a11y.view_cookie_policy_in_a_new_tab"),
                    link: userUiI18n.getString("privacy.cookies.cookie_policy_link")
                })}
            />
            <div className="uui-privacy__radio-group">
                <RadioGroup
                    value={props.settings.embedConsent.value.toString()}
                    items={embedConsentRadioGroupItems}
                    label={userUiI18n.getString("privacy.cookies.a11y.radio_group_label")}
                    onChange={(value) => props.actions.embedConsent(value === "true")}
                />
            </div>
        </Fragment>
    );
};
